<script lang="ts">
	import { capitalize, rnToBr } from '$lib/utils/strings';

	export let text: string;
	export let title: string;
</script>

{#if text}
	<section>
		<h2>{capitalize(title)}</h2>
		{#if text}
			{@html rnToBr(text)}
		{/if}
	</section>
{/if}
